export default __webpack_public_path__ + "static/media/icon-warning-o-large.912f710b.svg";